import { render, staticRenderFns } from "./TcEdit.vue?vue&type=template&id=a92a8ef4"
import script from "./TcEdit.vue?vue&type=script&lang=ts"
export * from "./TcEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports